/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ServiceTargetDTO } from '../../entities/service/TargetDTO'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { domainDriverCompanyTargetProgressStatusSchema } from '../domain/driverCompanyTargetProgressStatusSchema'
import { serviceMilestoneDTOSchema } from './milestoneDTOSchema'
import { z } from 'zod'

export const serviceTargetDTOSchema = z.object({
  done_orders: z.number().int(),
  due_date: z.string(),
  milestones: z.array(z.lazy(() => serviceMilestoneDTOSchema)).optional(),
  reward_amount: z.number().optional(),
  status: z.lazy(() => domainDriverCompanyTargetProgressStatusSchema),
  target_orders_count: z.number().int(),
}) as unknown as ToZod<ServiceTargetDTO>